module.exports = process.env.TEST ? console : {
  log: () => {},
}
